jQuery (function () {
    jQuery ('.location-filter a').on ('click', function () {

        jQuery ('.location-filter__link').removeClass ('active');
        jQuery (this).addClass ('active');

        var state = jQuery (this). data ('state-filter');
        

        jQuery ('.location-content').addClass ('hide');

        
        if (state == 'all') {
            jQuery ('.location-content').removeClass ('hide');
        } else {
            jQuery ('[data-state=' + state + ']').removeClass ('hide');
        }

        return false;
    });
});